import { Controller } from 'react-hook-form';
import DateTimeRangePicker from '../DateTimeRangePicker';

/** @param {import('rsuite').DateRangePickerProps & {name: string; control: any; rules?: any; hasError: boolean;}} param0 */
const FormDateTimeRangePicker = ({
    name,
    control,
    rules,
    hasError,
    ...props
}) => (
    <Controller
        name={name}
        control={control}
        rules={rules}
        render={({
            field: {
                onChange, onBlur, value, ref,
            },
        }) => (
            <DateTimeRangePicker
                {...props}
                // @ts-ignore
                onBlur={onBlur}
                value={value}
                ref={ref}
                onChange={onChange}
                hasError={hasError}
            />
        )}
    />
);

export default FormDateTimeRangePicker;
